import './NoContent.css'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import PlayersBlue from '../../icon/players-blue.svg'
import StructureBlue from '../../icon/structure_menu_blue.svg'
// import { ReactComponent as ExitBlueIcon } from '../../icon/exit-blue.svg'
// import { ReactComponent as AccountIcon } from '../../icon/account.svg'
import { useGetPlayersQuery } from '../../redux/playersService/playersApiSlice'

const NoContent = (props) => {
	const { t } = useTranslation()

	const communityUid = localStorage.getItem('communityUid')
	const {
		data: communityPlayers = [],
		isLoading
	} = useGetPlayersQuery({ community_uid: communityUid }, { skip: !props?.auth })

	return (
		<>
			<div className="nocontent__container">
				{
					props?.menuTabOrder < 3 &&
					<div className="nocontent__section">
						<p className="nocontent__title">
							{
								props?.menuTabOrder === 1 ?
									t('There are no grids yet')
									:
									t('No matches yet')
							}
						</p>

						{/* {
							(props?.tournament?.players?.length < 1 || props?.tournament?.doubles?.length < 1) && props?.auth &&
								<div className="nocontent__paragraph">
									<p className="nocontent__text">
										Вы пока не можете добавить участников в турнир. <br/>
										Перейдите в <Link to="/account" style={{ color: '#367BCF', fontWeight: '500' }}>Аккаунт</Link> и добавьте игроков
									</p>
								</div>
						} */}

						{
							(communityPlayers?.length === 0) && props?.auth &&
								<div className="nocontent__paragraph">
									<p className="nocontent__text">
										{ t('You cannot add participants to the tournament yet') }. <br/>
										{t('Go to')} <Link to="/account" style={{ color: '#367BCF', fontWeight: '500' }}>{t('Account')}</Link> {t('and add players')}
									</p>
								</div>
						}

						{
							props?.tournament?.stages_count < 1 && props?.auth &&
							<div className="nocontent__paragraph">
								<img src={StructureBlue} alt="Structure" />

								<p className="nocontent__text">
									{t('Add a stage in the structure tab')}
								</p>
							</div>
						}
					</div>
				}

				{props?.menuTabOrder === 3 &&
					<div className="nocontent__section">
						<p className="nocontent__title">
							{t('You can not create a stage yet')}
						</p>

						<div className="nocontent__paragraph">
							<img src={PlayersBlue} alt="Players" />
							<p className="nocontent__text">
								{t('Add players to the tournament in the participants tab')}
							</p>
						</div>
					</div>}
			</div>
		</>
	)
}

export default NoContent